import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Switch } from "../components/ui/switch";
import api, { money } from "../lib/api";

export default function AdminProducts() {
  const [products, setProducts] = useState([]);

  const load = () => api.get("/admin/products").then((r) => setProducts(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const toggle = async (p, field) => {
    await api.put(`/admin/products/${p.id}`, { ...p, [field]: !p[field] });
    load();
  };

  const remove = async (p) => {
    if (!window.confirm(`Excluir "${p.name}"?`)) return;
    await api.delete(`/admin/products/${p.id}`);
    toast.success("Produto excluído");
    load();
  };

  return (
    <div data-testid="admin-products">
      <div className="flex items-center justify-between mb-8">
        <h1 className="font-display text-3xl tracking-tight">Produtos</h1>
        <Button asChild className="bg-gold text-black hover:bg-gold-light" data-testid="new-product-button">
          <Link to="/admin/produtos/novo"><Plus size={15} className="mr-1.5" /> Novo produto</Link>
        </Button>
      </div>

      <div className="border border-white/10 rounded-lg overflow-x-auto">
        <table className="w-full text-sm min-w-[760px]" data-testid="products-table">
          <thead className="bg-white/5 text-zinc-400 text-xs uppercase tracking-wider">
            <tr>
              <th className="text-left px-5 py-3">Produto</th>
              <th className="text-left px-5 py-3">Tipo</th>
              <th className="text-left px-5 py-3">Preço</th>
              <th className="text-left px-5 py-3">Estoque</th>
              <th className="text-left px-5 py-3">Destaque</th>
              <th className="text-left px-5 py-3">Ativo</th>
              <th className="px-5 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {products.map((p) => {
              const prices = (p.variations || []).map((v) => v.promo_price || v.price);
              const stock = (p.variations || []).reduce((s, v) => s + (v.stock || 0), 0);
              return (
                <tr key={p.id} className="border-t border-white/5 hover:bg-white/[0.02]" data-testid={`product-row-${p.slug}`}>
                  <td className="px-5 py-3.5">
                    <div className="flex items-center gap-3">
                      {p.images?.[0] && <img src={p.images[0]} alt="" className="w-10 h-10 rounded object-cover" loading="lazy" />}
                      <span className="text-zinc-100">{p.name}</span>
                    </div>
                  </td>
                  <td className="px-5 py-3.5 text-zinc-400">{p.type === "digital" ? "Digital" : "Físico"}</td>
                  <td className="px-5 py-3.5 text-gold">{prices.length ? money(Math.min(...prices)) : "—"}</td>
                  <td className="px-5 py-3.5 text-zinc-300" data-testid="product-stock">{p.type === "digital" ? "∞" : stock}</td>
                  <td className="px-5 py-3.5"><Switch checked={!!p.featured} onCheckedChange={() => toggle(p, "featured")} data-testid="product-featured-switch" /></td>
                  <td className="px-5 py-3.5"><Switch checked={!!p.active} onCheckedChange={() => toggle(p, "active")} data-testid="product-active-switch" /></td>
                  <td className="px-5 py-3.5">
                    <div className="flex gap-2 justify-end">
                      <Button asChild size="sm" variant="ghost" className="text-zinc-400 hover:text-gold" data-testid="edit-product-button">
                        <Link to={`/admin/produtos/${p.id}`}><Pencil size={14} /></Link>
                      </Button>
                      <Button size="sm" variant="ghost" className="text-zinc-400 hover:text-red-400" onClick={() => remove(p)} data-testid="delete-product-button">
                        <Trash2 size={14} />
                      </Button>
                    </div>
                  </td>
                </tr>
              );
            })}
            {products.length === 0 && <tr><td colSpan={7} className="px-5 py-10 text-center text-zinc-600">Nenhum produto.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
